import { MinimalButton } from '@calendly/ui/components/minimal-button'

import { useI18n } from 'locales'

export default ({ closePopup }) => {
  const { i18n } = useI18n()
  return (
    <MinimalButton fontSize="medium" onClick={closePopup}>
      {i18n.t('booking.mutual_availability.login.nevermind_continue_scheduling')}
    </MinimalButton>
  )
}
